<template>
    <div class="flexible-space-wrapper space-a">
        <component
            v-for="component in activeComponents"
            :key="component.name"
            :is="component.name"
            v-bind="component.props"
        />
    </div>
</template>

<script>
import { flexibleSpaceMixin } from '@/mixins';
import { FLEXIBLE_COMPONENTS } from '@/constants';
import PodiumPro from '@molecules/PodiumPro/PodiumPro.vue';
const {
    PARTNER_PODIUM,
    CATEGORY_TAGS,
    HERO_SEARCH_BAR,
    HERO_BILLBOARD,
    BLACK_FRIDAY_BADGE,
    PODIUM_PRO,
} = FLEXIBLE_COMPONENTS;

export default {
    name: 'FlexibleSpaceA',
    components: {
        PodiumPro,
        [PARTNER_PODIUM]: () =>
            import('@molecules/PartnerPodium/PartnerPodiumContainer'),
        [CATEGORY_TAGS]: () => import('@organisms/CategoryTags/CategoryTags'),
        [HERO_SEARCH_BAR]: () =>
            import('@molecules/HeroSearchBar/HeroSearchBar'),
        [HERO_BILLBOARD]: () =>
            import('@molecules/HeroBillboard/HeroBillboard'),
        [BLACK_FRIDAY_BADGE]: () =>
            import('@molecules/BlackFridayBadge/BlackFridayBadge'),
        [PODIUM_PRO]: () => import('@molecules/PodiumPro/PodiumPro'),
    },
    mixins: [flexibleSpaceMixin],
    props: {
        billboardPartner: {
            type: [Object, Array],
        },
        podiumPartners: {
            type: Array,
        },
        isHeroBannerBeta: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        dynamicComponents() {
            return {
                [PODIUM_PRO]: {
                    shouldShow: this.$globalConstants.host.use_podium,
                    props: {
                        partners: this.podiumPartners,
                        applyHeroBannerBetaStyle: Boolean(
                            this.isHeroBannerBeta
                        ),
                        isPartnerRowZeta:
                            this.$globalConstants.components['CategoryPage'][
                                'partnerRowType'
                            ] === 'PartnerRowZeta',
                        ...this.$globalConstants.components[PODIUM_PRO],
                    },
                },
                [PARTNER_PODIUM]: {
                    shouldShow: this.$globalConstants.host.use_podium,
                    props: {
                        applyHeroBannerBetaStyle: Boolean(
                            this.isHeroBannerBeta
                        ),
                    },
                },
                [CATEGORY_TAGS]: {
                    shouldShow: this.$globalConstants.host['show_categories'],
                    props: {
                        ...this.$globalConstants.components[CATEGORY_TAGS],
                        applyHeroBannerBetaStyle: Boolean(
                            this.isHeroBannerBeta
                        ),
                    },
                },
                [HERO_SEARCH_BAR]: {
                    shouldShow: this.$globalConstants.host['search_bar'],
                    props: this.$globalConstants.components[HERO_SEARCH_BAR],
                },
                [HERO_BILLBOARD]: {
                    shouldShow:
                        this.$globalConstants.host[
                            'sidebar_billboard_desktop'
                        ] && Boolean(this.billboardPartner),
                    props: { partner: this.billboardPartner },
                },
                [BLACK_FRIDAY_BADGE]: {
                    shouldShow:
                        Boolean(
                            this.$globalConstants.host['black_friday_badge']
                        ) ||
                        Boolean(this.$globalConstants.host['christmas_badge']),
                    props: {
                        ...this.$globalConstants.components[BLACK_FRIDAY_BADGE],
                        christmasTheme: Boolean(
                            this.$globalConstants.host['christmas_badge']
                        ),
                    },
                },
            };
        },
        activeComponents() {
            return this.getActiveComponents(
                'CategoryPage',
                'A',
                this.dynamicComponents
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.flexible-space-wrapper {
    width: 100%;
    z-index: 2;
}
</style>
